import React from 'react';
import './progressbar.scss';
import {cls } from '../../packages/components';

const ProgressBar = ({percent = null}) => {
    return (
        percent ? 
        <div className={cls('aaf_progress_bar_meter')}>
            <span style={{width: `${percent}%`}}>
                <span className={cls('aaf_progress_bar_progress')}></span>
            </span>
        </div> : null
    );
};
export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/ProgressBar/index.jsx